import { styled } from "@mui/material";
import MainCard from "../MainCard";
import { colors } from "../../../utility/types/constant";

export const CardWrapper = styled(MainCard)(({ theme }) => ({
  backgroundColor: colors.white,
  color: "#fff",
  overflow: "hidden",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${colors.mediumGold} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
    borderRadius: "50%",
    top: -85,
    right: -95,
    [theme.breakpoints.down("sm")]: {
      top: -105,
      right: -140,
      background: `linear-gradient(140.9deg, ${colors.mediumGold} -14.02%, rgba(144, 202, 249, 0) 70.50%)`,
    },
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: colors.white,
    borderRadius: "50%",
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down("sm")]: {
      top: -155,
      right: -70,
      backgroundColor: colors.mediumGold,
    },
  },

  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(3), // or use margin: theme.spacing(2)
    // ... other styles for small screens
  },
}));
